import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';

import { parseISO } from 'date-fns';
import { tap } from 'rxjs';

import { checkDateObject, convertToISOString } from '@lvflanders/bar';

import { BarDateTimeConversionStrategy } from '../models/bar-date-time-conversion-strategy.enum';

// NOTE based on https://gist.github.com/martinobordin/39bb1fe3400a29c1078dec00ff76bba9
const ISO_8601_REGEX = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

export function barDateTimeInterceptor(conversionStrategy: BarDateTimeConversionStrategy): HttpInterceptorFn {
    return (req, next) => {
        traverseInput(req.body);
        return next(req).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const body = event.body;
                    traverseOutput(body);
                }
            })
        );
    };

    function traverseInput(body): void {
        traverse(
            body,
            (value) => checkDateObject(value),
            (value: Date) => toISO(value),
            (body) => traverseInput(body)
        );
    }

    function traverseOutput(body): void {
        traverse(
            body,
            (value) => isIso8601(value),
            (value) => parseISO(value),
            (body) => traverseOutput(body)
        );
    }

    function toISO(value: Date) {
        switch (conversionStrategy) {
            case BarDateTimeConversionStrategy.IsoGmt:
                return value.toISOString();
            default:
            case BarDateTimeConversionStrategy.Iso:
                return convertToISOString(value);
        }
    }

    function traverse(body, matcher: (any) => boolean, converter: (any) => any, traverser: (any) => void): void {
        if (body == null || typeof body !== 'object') return;

        if (Array.isArray(body)) {
            for (let i = 0; i < body.length; i++) {
                const value = body[i];
                if (matcher(value)) {
                    body[i] = converter(value);
                } else if (typeof value === 'object') {
                    traverser(value);
                }
            }
        } else {
            for (const key of Object.keys(body)) {
                const value = body[key];
                if (matcher(value)) {
                    body[key] = converter(value);
                } else if (typeof value === 'object') {
                    traverser(value);
                }
            }
        }
    }

    function isIso8601(value) {
        if (value === null || value === undefined) return false;
        return ISO_8601_REGEX.test(value);
    }
}
